import React from 'react';
// @ts-ignore
import styles from './Confirmation.module.scss';
import useTranslation from '../../../../Hooks/useTranslation';
interface Props {
	text: string;
	imageSource?: string;
	children?: React.ReactElement | React.ReactElement[];
}

const Confirmation: React.FC<Props> = ({ text, imageSource, children }) => {
	const { t } = useTranslation();
	return (
		<div className={styles.wrapper}>
			<div className={styles.greyBox}>
				{imageSource && <img src={imageSource} alt='checked' />}
				<p>{t(text)}</p>
			</div>
			<div className={styles.whiteBox}>{children}</div>
		</div>
	);
};

export default Confirmation;
